import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import WorkspaceContainer, {WorkspaceName} from "../table/workspace/WorkspaceContainer";
import Routes from "../../../navigation/route/Route";
import CreateJobButton from "../../job/table/CreateJobButton";
import SortColumnModel from "../../../model/workspace/SortColumnModel";
import {option} from "ts-option";
import ActionsColumn from "../table/ActionsColumn";
import {CellInfo} from "react-table";
import {WildcardFilterColumnType} from "../../../model/workspace/WildcardFilter";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import JobStatusBulkChangeModal, {BulkChangeJobStatusData} from "../../job/status/JobStatusBulkChangeModal";
import EcmsImportModal from "../../job/ecmsImport/EcmsImportModal";
import {store} from "../../../navigation/ReduxProvider";
import {UserPermission} from "../../../model/user/UserPermission";

interface State {
	selectedData: BulkChangeJobStatusData[]
	showChangeStatusModal: boolean
	showEcmsImportModal: boolean
}

type Props = RouteComponentProps<any>;

const defaultSort = option(new SortColumnModel("1d2d01bf-7f6d-4b7e-b5b0-0f58eeebefbb", "updateDate", false));


class JobWorkspaceContainer extends React.Component<Props, State> {
	refs: {
		workspaceContainer: WorkspaceContainer;
	};

	constructor(props: Props) {
		super(props);
		this.state = {
			selectedData: [],
			showChangeStatusModal: false,
			showEcmsImportModal: false
		}
	}

	render() {
		return (
			<>
				<WorkspaceContainer ref={"workspaceContainer"}
									workspaceName={WorkspaceName.Jobs}
									onRowClick={(rowId: string) => this.props.history.push(Routes.EditJob(rowId))}
									rowToId={(row) => row.referenceNumber}
									renderButton={this.renderActionBtn}
									sortable
									defaultSort={defaultSort}
									onSelectionChange={this.onSelectionChange}
									wildcardFilterColumnType={WildcardFilterColumnType.LeadJobs}
									pageSize={100}
									lastColumn={(row: CellInfo) => <ActionsColumn
										route={Routes.EditJob(row.original.referenceNumber)}/>}/>
				{this.state.showChangeStatusModal &&
				<JobStatusBulkChangeModal jobsData={this.state.selectedData}
										  onCancel={this.hideChangeStatusModal}
										  onSuccess={this.onJobStatusUpdateSuccess}/>}
			{this.state.showEcmsImportModal &&
				<EcmsImportModal
					onCancel={this.hideEcmsImportModal}
					onSuccess={this.onEcmsImportSuccess}/>}
			</>
		)
	}

	renderActionBtn = () => {
		return (
			<>
				<ButtonPrimary customStyles={{marginRight: 10}}
							   variant={"burgundy"}
							   disabled={this.state.selectedData.length == 0}
							   label={"Change status"}
							   onClick={this.showChangeStatusModal}/>
				<CreateJobButton/>
				{this.canEnterEvChargingBills() &&
				<ButtonPrimary
					label="New EV charging job"
					onClick={() => this.props.history.push(Routes.CreateEvChargingJob)}
					variant="burgundy"
					customStyles={{marginLeft: 10}}/>}
				<ButtonPrimary
					label="Upload ECMS file"
					onClick={this.showEcmsImportModal}
					variant="burgundy"
					customStyles={{marginLeft: 10}}/>
			</>
		)
	}

	showChangeStatusModal = () => {
		this.setState({showChangeStatusModal: true})
	}

	hideChangeStatusModal = () => {
		this.setState({showChangeStatusModal: false})
	}

	/**
	 * Only admins enter EV charging bills; the backend refuses everyone else, so others are not offered the button.
	 */
	canEnterEvChargingBills = () =>
		store.getState().user.user.exists(user => user.hasPermissions([UserPermission.AdminAll]));

	showEcmsImportModal = () => this.setState({showEcmsImportModal: true});
	hideEcmsImportModal = () => this.setState({showEcmsImportModal: false});
	onEcmsImportSuccess = () => {
		if (this.refs.workspaceContainer && this.refs.workspaceContainer.refreshData) {
			this.refs.workspaceContainer.refreshData();
		}
		this.setState({showEcmsImportModal: false});
	};

	onSelectionChange = (selectedRows: any[]) => {
		this.setState({selectedData: this.convertToBulkChangeJobStatusData(selectedRows)})
	}

	onJobStatusUpdateSuccess = () => {
		if(this.refs.workspaceContainer && this.refs.workspaceContainer.refreshData) {
			this.refs.workspaceContainer.refreshData();
		}
		this.setState({showChangeStatusModal: false});
	}

	convertToBulkChangeJobStatusData = (data: any[]): BulkChangeJobStatusData[] => {
		return data.map(d => {
			return {
				id: d.id,
				referenceNumber: d.referenceNumber,
				customer: d.contact.name,
				status: d.statusName
			}
		})
	}
}

export default withRouter(JobWorkspaceContainer);
